import React from "react";
import styled from "styled-components";
import {useDataSource} from "src/core/data-sources/decorators/withData";
import useRouter from "src/core/common/hooks/useRouter";
import {
  ModalActionContainer,
  ModalSectionButton,
  ModalText,
  ModalTitle,
} from "src/core/common/components/modules/modal/modalComponents";
import StrongholdPaymentSourcesDataSource from "src/core/payments/stronghold/strongholdPaymentSourcesDataSource";
import get from "lodash/get";
import BankIcon from "src/core/payments/stronghold/bank-icons/LazyBankIcon";
import {Pencil} from "styled-icons/heroicons-outline/Pencil";

export default function Stronghold({editAccountRoute}) {
  const router = useRouter();

  const shPaymentSourcesDataSource = new StrongholdPaymentSourcesDataSource();
  const {shPaymentSources} = useDataSource(
    {},
    {
      dataSource: shPaymentSourcesDataSource,
      keyFields: [],
      dataField: "shPaymentSources",
    }
  );
  const defaultShPaymentMethod =
    shPaymentSources && shPaymentSources.find((pSource) => pSource.isDefault);
  const shProvider = get(defaultShPaymentMethod, "institution");
  const shProviderIcon = defaultShPaymentMethod && shProvider && (
    <BankIcon bank={shProvider} />
  );
  const shProviderDisplay = get(defaultShPaymentMethod, "institutionName");
  const shLabelDisplay = get(defaultShPaymentMethod, "label");

  return (
    <>
      <ModalTitle>Accounts</ModalTitle>
      <ModalSectionButton
        data-cy="defaultPaymentMethodButton"
        onClick={() => router.push(editAccountRoute)}
      >
        <ModalText>
          {defaultShPaymentMethod ? (
            <ProviderContainer>
              <ProviderIcon>{shProviderIcon}</ProviderIcon>
              <ProviderDisplay>{shProviderDisplay}</ProviderDisplay>
              <ProviderLabel>{shLabelDisplay}</ProviderLabel>
            </ProviderContainer>
          ) : (
            "Set default payment account..."
          )}
        </ModalText>
        <ModalActionContainer>
          <PencilIcon />
        </ModalActionContainer>
      </ModalSectionButton>
    </>
  );
}

const ProviderContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ProviderIcon = styled.span`
  padding-right: 8px;
  height: 30px;
`;

const ProviderDisplay = styled.span`
  padding-right: 8px;
`;

const ProviderLabel = styled.span`
  color: ${({theme}) => theme.v2.color.base.grey["700"]};
  font-weight: 400;
`;

const PencilIcon = styled(Pencil)`
  height: 20px;
  width: 20px;
  color: black;
`;
